import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
	
	},

	getters: {
	
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
	
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
	
	}
}